import { getFileDownloadUrl } from 'src/utils/helpers/fileUrl';

const downloadFileAsUpload = async (fileInput) => {
	const fileId = fileInput?.id;

	if (!fileId) return fileInput;

	const url = getFileDownloadUrl(fileId);

	if (!url) {
		throw new Error('Не удалось определить адрес файла');
	}

	const response = await fetch(url, { credentials: 'include' });

	if (!response.ok) {
		throw new Error('Не удалось получить файл для сохранения изменений');
	}

	const blob = await response.blob();
	const name = fileInput.name || 'file';

	return {
		name,
		upload: new File([blob], name, {
			type: blob.type || 'application/octet-stream',
		}),
	};
};

const materializeFileField = async (fileInput) => {
	if (!fileInput) return fileInput;

	if (fileInput.upload instanceof File || fileInput.upload instanceof Blob) {
		return fileInput;
	}

	if (fileInput.id) {
		return downloadFileAsUpload(fileInput);
	}

	return fileInput;
};

/**
 * UpdateActivity compensates previous contract/document steps and deletes their
 * files before recreating items. Existing files must be re-uploaded as Upload
 * blobs, not referenced by id.
 */
export const materializeFileInputs = async (input = {}) => {
	const next = { ...input };

	if (Array.isArray(input.contracts) && input.contracts.length) {
		next.contracts = await Promise.all(
			input.contracts.map(async (contract) => ({
				...contract,
				file: await materializeFileField(contract.file),
			})),
		);
	}

	if (Array.isArray(input.documents) && input.documents.length) {
		next.documents = await Promise.all(
			input.documents.map(async (document) => ({
				...document,
				file: await materializeFileField(document.file),
			})),
		);
	}

	return next;
};
